import { useState } from 'react'

/**
 * True on the first render, and on any later render where at least one
 * entry of `deps` differs (by `===`) from the same-index entry on the
 * previous render -- matching `useEffect([...deps])`, which always runs
 * once on mount in addition to whenever a dependency changes. Mirrors
 * `useEffect`'s dependency-array ergonomics for the "reset/adjust state
 * when an input changes" idiom, done during render instead of in a
 * `useEffect` + `setState` pair (react-hooks/set-state-in-effect):
 * https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
 */
export function useChangedDeps(deps: ReadonlyArray<unknown>): boolean {
  const [prevDeps, setPrevDeps] = useState<ReadonlyArray<unknown> | null>(null)
  const changed =
    prevDeps === null ||
    deps.length !== prevDeps.length ||
    deps.some((dep, index) => dep !== prevDeps[index])
  if (changed) {
    setPrevDeps(deps)
  }
  return changed
}
